export default {
    ca: {
        title: 'Taller del nou Instamaps (per a tots els usuaris) dijous 22 de noviembre a les 18:30',
        message: 'Inscriviu-vos ',
        messageLink: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps',
        messageLinkText: 'aquí',
    },
    es: {
        title: 'Taller del nuevo Instamaps (para todos los usuarios) jueves 22 de noviembre a las 18:30',
        message: 'Regístrese ',
        messageLink: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps',
        messageLinkText: 'aquí',
    },
    en: {
        title: 'Workshop of the new Instamaps (for all users) Thursday, November 22 at 18:30',
        message: 'Sign up ',
        messageLink: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps',
        messageLinkText: 'here',
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/inscripcio-modal/inscripcio-modal-translations.js